export const UPLOAD_STATUSES = {
    ERROR: 'error',
    PENDING: 'pending',
    OPTIMIZING: 'optimizing',
    UPLOADING: 'uploading',
    COMPLETED: 'completed',
};

export const UPLOAD_SUBMIT_STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    PENDING: 'pending',
    SUCCESS: 'success',
});

export const CompleteStatuses = Object.freeze({
    ACCEPTED: "ΑΠΟΔΕΚΤΗ",
    PENDING: "ΕΚΚΡΕΜΟΤΗΤΑ",
    FOR_APPROVAL: "ΠΡΟΣ ΕΓΚΡΙΣΗ",
    APPLICATION_REVIEW: "ΕΛΕΓΧΟΣ ΑΙΤΗΣΗΣ",
    DOCS_REVIEW: "ΕΛΕΓΧΟΣ ΔΙΚΑΙΟΛΟΓΗΤΙΚΩΝ",
    AWAITING_DOCS: "ΑΝΑΜΟΝΗ ΔΙΚΑΙΟΛΟΓΗΤΙΚΩΝ",
});

export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const ERROR_MESSAGE = 'Σφάλμα - Δοκίμασε ξανά';
export const ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'jpeg', 'jpg', 'png', 'gif', 'tiff', 'tif', 'bmp'];
export const ALLOWED_MIME_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/tiff',
    'image/bmp',
];
export const ACCEPT_ATTR = '.pdf,.doc,.docx,.png,.jpg,.jpeg,.gif,.tif,.tiff,.bmp,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/png,image/jpeg,image/gif,image/tiff,image/bmp';

export const getFileType = (file) => {
    const name = file?.name ?? '';
    const dotIndex = name.lastIndexOf('.');
    const ext = dotIndex > 0 && dotIndex < name.length - 1 ? name.slice(dotIndex + 1) : '';
    if (ext) {
        return ext.toUpperCase();
    }
    const mimeExt = file?.type?.split('/').pop();
    return mimeExt ? mimeExt.toUpperCase() : 'PDF';
};

export const formatFileSize = (size = 0) => {
    const KB = 1024;
    const MB = KB * 1024;
    if (!size) {
        return '';
    }
    if (size >= MB) {
        return `${(size / MB).toFixed(1)} MB`;
    }
    if (size >= KB) {
        return `${Math.round(size / KB)} KB`;
    }
    return `${size} B`;
};

export const buildUploadDocuments = (requested = []) => (
    requested
        .map((doc) => {
            if (!doc?.label) {
                return null;
            }
            const id = doc.id ?? doc.key ?? doc.label;
            const key = doc.key ?? doc.id ?? doc.label;
            return {
                id,
                key,
                label: doc.label,
            };
        })
        .filter(Boolean)
);

export const normalizeDocuments = (documents) => {
    if (!documents || typeof documents !== 'object') {
        return {};
    }

    return Object.entries(documents).reduce((acc, [key, label]) => {
        if (key != null && label != null) {
            acc[key] = label;
        }
        return acc;
    }, {});
};
